import ResourceGetter   from './resource/getter/resource-getter'
import { DataTypes }    from './data-types'
import DatetimeParser   from './parser/datetime-parser'
import DefinitionGetter from './resource/getter/definitions-getter'
import tippy            from 'tippy.js'

export class PrepareTooltipData {

  cache = []

  prepare (
    element,
    entityCode,
    itemId,
    successCallback,
    errorCallback,
    translator
  ) {

    if (!entityCode || !itemId) {
      console.error('entityCode or itemId missing.')
      return
    }

    for (const storedElm of this.cache) {
      if (element === storedElm && element._tippy) {
        return
      }
    }

    if (!element._tippy) {
      this.cache.push(element)
    }

    let args    = {
          code:                   entityCode,
          idtEntityStructureFrom: '0'
        },
        success = (def) => {

          const resource = ResourceGetter.get(def.viewName)
          let content    = `<table>`

          resource
            .setDef(def)
            .getById(itemId).then((response) => {
            for (const gridItem of def.filteredGrid) {
              const dicKeyCode = gridItem.DictionaryKeyCode
                ? gridItem.DictionaryKeyCode
                : gridItem.Label,
                    dataType   = gridItem.DataType,
                    title      = translator.text(dicKeyCode)

              let value = response.data[0] &&
              response.data[0][gridItem.ColumnName]
                ? response.data[0][gridItem.ColumnName]
                : ''

              if (dataType === DataTypes.datetime) {
                value = DatetimeParser.dateObjectToDateTime(new Date(value))
              }

              content += `<tr><th nowrap="nowrap">${title}</th><td>${value}</td></tr>`
            }

            content += `</table>`

            const tooltip = tippy(element, {
              content:     content,
              placement:   'auto',
              trigger:     'mouseenter focus',
              allowHTML:   true,
              hideOnClick: true,
              maxWidth:    'none',
              delay:       [0, 0],
              appendTo:    () => document.body
            })

            successCallback(tooltip)
          })
        }

    DefinitionGetter
      .getDataDefinition(
        args, success, (error) => {errorCallback(error) })
  }
}
